import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import lengthTemplate from 'properties/main/length.ejs';
import imageUtil from 'util/ImageUtil.js';

class MainLengthView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = lengthTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=number]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if (!this.model.get('length')) {
            this.model.set('length', '7', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();

        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        if(this.model.get('factoryKey') === 'control_captcha' && propName === 'length'){
            this.model.set('keepText', false,{silent:true})
        }
        this.model.set( propName, propVal );
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainLengthView;
